@if (resourceSelectionWarning() || resourceRemovalNotifications().length > 0) {
  <div class="resource-notification-layer">
    @if (resourceSelectionWarning(); as warning) {
      <div class="safe-padding resource-selection-warning-wrapper">
        <div class="resource-selection-warning" [attr.role]="warning.confirmation ? 'alertdialog' : 'alert'">
          <div class="resource-selection-warning-header">
            <span class="resource-selection-warning-icon" aria-hidden="true">!</span>
            <p>{{ warning.messageKey | transloco: { resource: warning.resourceName } }}</p>
            @if (!warning.confirmation) {
              <button
                class="resource-selection-warning-close"
                (click)="closeResourceSelectionWarning()"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            }
          </div>
          <addin-resource-availability
            [isRestrictedResource]="warning.resource.isAssignedTo === resourceAssignType.Restricted"
            [unavailabilityReason]="warning.resource.unavailabilityReason"
            [unavailabilityReasonValue]="warning.resource.unavailabilityReasonValue"
            [timeline]="warning.resource.timeLine"
            [startDate]="warning.start"
            [endDate]="warning.end"
          >
          </addin-resource-availability>
          @if (warning.confirmation) {
            <div class="resource-notification-actions">
              <button
                class="small"
                [class.primary]="warning.confirmation.defaultAction === 'secondary'"
                [class.secondary]="warning.confirmation.defaultAction !== 'secondary'"
                (click)="cancelResourceSelectionWarning()"
              >
                {{ warning.confirmation.secondaryLabelKey ?? translation.outlookAddin.confirmationNo | transloco }}
              </button>
              <button
                class="small"
                [class.primary]="warning.confirmation.defaultAction !== 'secondary'"
                [class.secondary]="warning.confirmation.defaultAction === 'secondary'"
                (click)="confirmResourceSelectionWarning()"
              >
                {{ warning.confirmation.primaryLabelKey ?? translation.outlookAddin.confirmationYes | transloco }}
              </button>
            </div>
          }
          <div
            class="notification-countdown notification-countdown-error"
            [class.notification-countdown-even]="warning.countdownId % 2 === 0"
            [class.notification-countdown-odd]="warning.countdownId % 2 !== 0"
            [style.--notification-timeout-ms]="warning.timeoutMs + 'ms'"
            aria-hidden="true"
          ></div>
        </div>
      </div>
    }
    @if (resourceRemovalNotifications().length > 0) {
      <div class="safe-padding resource-removal-notifications">
        @for (notification of resourceRemovalNotifications(); track notification.id) {
          <div
            class="resource-removal-notification"
            [class.resource-removal-notification-multiple]="notification.resourceDetails.length > 1"
            role="status"
          >
            <div class="resource-removal-notification-header">
              <span class="resource-removal-notification-icon" aria-hidden="true">!</span>
              <p>
                @if (notification.confirmation) {
                  {{
                    notification.messageKey
                      | transloco: { resource: notification.resources, resources: notification.resources }
                  }}
                } @else if (notification.resourceDetails.length > 1) {
                  {{ translation.outlookAddin.resourcesRemovedFromEvent | transloco }}
                } @else {
                  {{ notification.messageKey | transloco: { resources: notification.resources } }}
                }
              </p>
              @if (!notification.confirmation) {
                <button
                  class="resource-removal-notification-close"
                  (click)="closeResourceRemovalNotification(notification.id)"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              }
            </div>
            <div class="resource-removal-notification-details">
              @for (
                notificationResource of notification.resourceDetails;
                track notificationResource.resource.resourceId
              ) {
                <div class="resource-removal-notification-resource">
                  @if (notification.resourceDetails.length > 1) {
                    <p class="resource-removal-notification-resource-name">{{ notificationResource.displayName }}</p>
                  }
                  <addin-resource-availability
                    [isRestrictedResource]="
                      notificationResource.resource.isAssignedTo === resourceAssignType.Restricted
                    "
                    [unavailabilityReason]="notificationResource.resource.unavailabilityReason"
                    [unavailabilityReasonValue]="notificationResource.resource.unavailabilityReasonValue"
                    [timeline]="notificationResource.resource.timeLine"
                    [startDate]="notification.start"
                    [endDate]="notification.end"
                  >
                  </addin-resource-availability>
                </div>
              }
            </div>
            @if (notification.confirmation) {
              <div class="resource-notification-actions">
                <button class="small primary" (click)="confirmResourceRemovalNotification(notification.id)">
                  {{ translation.outlookAddin.confirmationYes | transloco }}
                </button>
                <button class="small secondary" (click)="cancelResourceRemovalNotification(notification.id)">
                  {{ translation.outlookAddin.confirmationNo | transloco }}
                </button>
              </div>
            }
            <div
              class="notification-countdown notification-countdown-warning"
              [class.notification-countdown-even]="notification.id % 2 === 0"
              [class.notification-countdown-odd]="notification.id % 2 !== 0"
              [style.--notification-timeout-ms]="notification.timeoutMs + 'ms'"
              aria-hidden="true"
            ></div>
          </div>
        }
      </div>
    }
  </div>
}
@if (!showFilter) {
  <div class="safe-padding filter-button">
    <button (click)="showFilter = !showFilter" class="small">
      <cue-icon [icon]="cueFilter"></cue-icon>
      {{ translation.outlookAddin.openFilters | transloco }}
    </button>

    @if (reqCount$ | async; as requirementsCount) {
      <div class="remove-filters">
        {{ requirementsCount }}
        {{ translation.outlookAddin.activeFilterCount | transloco }}
        <cue-icon [icon]="cueClose" (click)="resetAllFilters()"></cue-icon>
      </div>
    }
  </div>
}
@if (showFilter) {
  <addin-resource-filter
    [filterCount]="reqCount$ | async"
    [hierarchyAreas]="hierarchyAreas$ | async"
    [currentFilter]="currentResourceFilter$ | async"
    [areas]="areas$ | async"
    [resourceFilters]="resourcesFilter$ | async"
    (refreshFilter)="showFilter = false"
  >
  </addin-resource-filter>
}
<addin-resource-list
  (refresh)="onRefresh()"
  (resourceSelectionWarningChange)="setResourceSelectionWarning($event)"
  (resourceNotification)="showResourceRemovalNotification($event)"
  [hidden]="showFilter"
  [resourceFilter]="currentResourceFilter$ | async"
  [resourceFilters]="(resourcesFilter$ | async) ?? []"
  [resourceList]="resourceList$ | async"
  [groupedResourceList]="groupedResourceList$ | async"
>
</addin-resource-list>
